/** Согласовано с ``CREATIVE_PORTAL_ELIGIBLE_POSITIONS`` в api/utils/employee_positions.py */
const CREATIVE_PORTAL_NORMALIZED_POSITIONS = new Set(['Designer', 'Zam', 'Control', 'Manager'])

export function employeeHasCreativePortalAccess(user: {
  role?: string
  creative_portal_access?: boolean
  normalized_position?: string | null
}): boolean {
  if (user.role === 'admin') return true
  if (user.role !== 'employee') return false
  if (user.creative_portal_access) return true
  const p = (user.normalized_position || '').trim()
  return CREATIVE_PORTAL_NORMALIZED_POSITIONS.has(p)
}
